module.exports = __webpack_public_path__ + "static/media/circle6.21278e1d.svg";